import React, { Component } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { IAppActionDispatches, mapAppDispatchToProps } from "../../../redux/actions/app";
import { IAppState, mapAppStateToProps } from "../../../redux/reducers/app";
import { WidgetProps } from "..";
import { ISiteTextContent } from "../../../models/cms";
import { UICMSContent } from "../../ui/UICMSContent";

class EditorContent extends Component<IAppActionDispatches & IAppState & WidgetProps> {
	get textContent(): ISiteTextContent[] {
		return (this.props.textContent || []).filter((c: ISiteTextContent) =>
			this.props.inHeader
				? c.pageId === this.props.activePage?.id && c.displayInHeader
				: c.pageId === this.props.activePage?.id
		);
	}

	componentDidMount() {
		console.log("componentDidMount page:", this.props.activePage);
	}

	render() {
		console.log("render page content:", this.props.activePage);
		return this.textContent.map((c: ISiteTextContent) => (
			<div
				className={clsx(
					"container",
					!this.props.inHeader && !c.noPadding && "section-padding",
					c.bgColor ? `bg-${c.bgColor || "white"}` : ""
				)}
			>
				<UICMSContent content={c.content} />
			</div>
		));
		// return (
		// 	<div className={clsx("container", !this.props.inHeader && "section-padding")}>

		// 	</div>
		// );
	}
}

export default connect<IAppState, IAppActionDispatches, WidgetProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(EditorContent);
